import { Layout, Drawer, Divider } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { screenSize } from '@src/constants/ScreenSize';
import {
    THEME,
    selectLayout,
    setCollapsed,
} from '@src/store/layout/layoutSlice';
import { UserInfo } from '../Navbar/NavbarInfo/UserInfo';
import Navbar from '../Navbar/Navbar';
import clsx from 'clsx';

interface ISidebar {
    menu: React.ReactNode;
}

export default function SideBar({ menu }: ISidebar) {
    const layout = useSelector(selectLayout);
    const dispatch = useDispatch();
    const isXl = useMediaQuery({ minWidth: screenSize.xl });
    const isLg = useMediaQuery({ minWidth: screenSize.lg });

    const isDark = layout.theme === THEME.DARK;

    return (
        <div
            className={clsx(
                `bg-white m-2 rounded-xl p-2 lg:min-w-fit `,
                { 'overflow-y-scroll h-[calc(100vh-17px)]': isLg },
                { 'min-w-[220px]': !layout.collapsed && isLg },
                { 'min-w-[80px]': layout.collapsed && isLg }
            )}
        >
            <Navbar />
            {isLg && <Divider />}
            {isLg ? (
                <Layout.Sider
                    className={clsx(
                        ` overflow-y-scroll overflow-x-hidden !min-w-[60px]`,
                        { 'h-[calc(100vh-154px)] min-h-[460px]': isLg },
                        {
                            'h-[calc(100vh-157px)] !min-h-[363px]':
                                layout.collapsed && isLg,
                        }
                    )}
                    theme={layout.theme}
                    collapsed={layout.collapsed}
                    collapsedWidth={isXl ? 60 : 0}
                    breakpoint="lg"
                    trigger={null}
                    collapsible
                >
                    {menu}
                </Layout.Sider>
            ) : (
                <Drawer
                    open={!layout.collapsed}
                    placement="left"
                    width={280}
                    closable={false}
                    // title={
                    //     <div className="pt-6 px-4 border-b border-primary/20">
                    //         <div className="px-2">
                    //             <UserInfo isMobile />
                    //         </div>
                    //     </div>
                    // }
                    onClose={() => dispatch(setCollapsed(!layout.collapsed))}
                    styles={{
                        content: isDark
                            ? {
                                  backgroundColor: '#00042E',
                                  color: '#FFFFFF',
                              }
                            : {},
                        header: { border: 'unset', padding: '0' },
                        body: {
                            padding: '0',
                            color: '#FFFFFF',
                        },
                    }}
                >
                    {menu}
                </Drawer>
            )}
        </div>
    );
}
